/**
 * `$can`, `$canAny` and `$isFilterLocked` on every component.
 *
 *   <v-btn :disabled="!$can('los.cam.approve')">Approve</v-btn>
 *   <PermissionGate code="los.cam.approve" v-slot="{ disabled }">...</PermissionGate>
 *
 * They read the Vuex `access` module, so templates re-render when access is
 * refetched. A button the teammate lacks the permission for stays visible but
 * disabled (except the Leads row actions, which are hidden -- AgentList.vue);
 * tabs they cannot view are hidden. The server enforces the same
 * codes -- this is presentation, not the check.
 */
import store from "@/store";

export function can(code) {
  return store.getters["access/can"](code);
}

export default {
  install(Vue) {
    Vue.prototype.$can = can;
    Vue.prototype.$canAny = (...codes) => can(codes.flat());
    Vue.prototype.$isFilterLocked = (tab, key) =>
      store.getters["access/isFilterLocked"](tab, key);
  },
};
